import { Modal } from "react-bootstrap";
import { useGetCustomerHooks } from "../../utils/CustomerUtilHooks";
import { CustomerActiveBadge } from "./CustomerBadge";
import { useState } from "react";
import { downloadCustomerContract } from "../../api/customer";
import AlertBox from "../AlertBox";

export default function ModalDownloadContract({ show, id, onClose, onSuccess }) {
  const [loading, setLoading] = useState(null);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const { data } = useGetCustomerHooks({ id });
  const handleClose = () => {
    if (!loading) {
      setAlert({ show: false, message: "", type: "" });
      onClose();
    }
  };

  const handleDownloadConfirm = async () => {
    setLoading(true);

    try {
      let response = await downloadCustomerContract(id);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `BAST-${data.registration?.registration_number}.pdf`);
      onSuccess(`Berhasil mengunduh BAST-${data.registration?.registration_number}.pdf`);
      document.body.appendChild(link);
      link.click();
      handleClose();
    } catch (error) {
      let message = "Something wrong ... ";

      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download Kontrak Pelanggan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />

        <div className="row">
          <div className="col-12">
            <h6>Konfirmasi Download Kontrak</h6>
            <p>Apakah Anda yakin ingin mengunduh kontrak untuk pelanggan berikut?</p>

            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <strong>Nama Lengkap</strong>
                  </td>
                  <td>{data.name}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Alamat</strong>
                  </td>
                  <td>{data.address}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Nomor Registrasi</strong>
                  </td>
                  <td>{data.registration?.registration_number}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Status</strong>
                  </td>
                  <td>
                    <CustomerActiveBadge status={data.is_active} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Batal
        </button>
        <button className="btn btn-primary" onClick={handleDownloadConfirm} disabled={loading}>
          <i className="fas fa-download"></i> {loading ? "Mengunduh ..." : "Download Kontrak"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
